import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HandleError } from '../../utils/handler-error';
import { ResponseData } from '../../utils/response';
import { Supplier } from './supplier';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  constructor(private http: HttpClient) {}

  public findProviders(): Observable<ResponseData<Supplier[]>> {
    return this.http.get<ResponseData<Supplier[]>>(`${environment.API}/supplier`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public createSupplier(supplier: Supplier): Observable<ResponseData<Supplier>> {
    return this.http.post<ResponseData<Supplier>>(`${environment.API}/supplier`, supplier)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public updateSupplier(supplier: Supplier): Observable<ResponseData<Supplier>> {
    return this.http.put<ResponseData<Supplier>>(`${environment.API}/supplier`, supplier)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }
}